import { Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { Observable, throwError, timer } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

/**
 * TranslationService is responsible for fetching translations using Transloco.
 * It includes retry logic to handle cases where the translation file might not have loaded yet.
 */
@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  constructor(private translocoService: TranslocoService) {}

  translateObjectWithRetry(translocoKey: string, maxRetries: number = 3, retryDelayMS: number = 500): Observable<any> {
    let retries = 0; // Counter for retry attempts

    return new Observable(observer => {
      retries++; // Increment retry counter each time the Observable is subscribed to
      const translatedObject = this.translocoService.translateObject(translocoKey);

      if (!translatedObject || typeof translatedObject === 'string') {
        console.log(`Transloco trying again (attempt ${retries} of ${maxRetries})`);
        observer.error(`Transloco failed to translate the object ${translocoKey}`);
      } else {
        console.log('Translation successful');
        observer.next(translatedObject);
        observer.complete();
      }
    }).pipe(
      catchError(err => {
        console.error('Failed to translate', err);
        if (retries >= maxRetries) {
          console.log('Max retries reached');
        }
        return throwError(() => err);
      }),
      retry({
        count: maxRetries, // Maximum number of retry attempts
        delay: () => timer(retryDelayMS) // Number of ms to wait between attempts
      })
    );
  }
}
